var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.53 755.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #101010;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1101.79,
    y1: -399.99,
    x2: -862.22,
    y2: -399.99,
    gradientTransform: "translate(957.18 1182.44) rotate(20.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81338a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c26aa7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m382.47,76.99h0c0,.77-.14,2.36-.41,4.63-.16,1.31-.36,2.84-.6,4.58-.02.17-.04.32-.06.47-3.99,29.21-18.1,112.42-23.14,136.22,0,0-23.88,4.26-53.32,12.01h-.03s-.06.02-.09.03c-19.41,4.83-66.43,18.2-103.42,35.37h.02c-46.07,20.23-88.76,46.48-129.15,76.81-4.88,3.65-9.77,7.28-16.24,12.11,1.05-4.24,1.41-6.77,2.3-9.09,25.4-66.04,64.16-122.76,118.02-168.95,42.07-36.08,89.63-62.8,140.95-83.19,17.66-7.02,35.67-13.02,53.82-18.54,1.44-.44,2.87-.87,4.29-1.29h0c1.31-.39,4.27-1.32,7.16-2.22-.03.33-.07.69-.11,1.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m345.16,282.26c-.26,1.67-.56,3.57-.87,5.59,0,1.49-.41,2.98-.69,4.41,0,.03,0,.04-.01.07-.19,1.21-.39,2.45-.57,3.69-.2,1.24-.39,2.5-.58,3.74-.03.18-.05.37-.09.55-.14.92-.28,1.86-.43,2.78-.08.51-.15,1.01-.23,1.51-.09.61-.18,1.2-.28,1.8-.13.86-.27,1.72-.4,2.59-.48,3.08-.91,5.82-1.23,7.94-.06.36-.11.73-.17,1.09-.06.34-.11.66-.15.96-2.53,16.34-5.1,32.68-7.64,49.01-2.31,14.76-4.63,29.52-7,44.28-.54,3.37-1.26,6.71-2.01,10.61-3.27,1.14-6.43,2.37-9.67,3.37-35.96,11.02-71.11,24.06-104.28,41.98-20.99,11.34-40.71,24.53-57.96,41.16-20.01,19.29-34.85,41.65-41.35,69.07-4.89,20.58-4.28,41.16.42,61.54,2.57,11.16,6.73,21.95,10.18,32.89.68,2.15,1.39,4.29,2.08,6.43-29.51-33.6-54.36-69.77-69.02-112.02-7.09-20.44-11.12-41.39-10.09-63.2,1.42-30.16,12.21-56.68,30.47-80.4,12.73-16.54,27.99-30.47,44.65-42.93,26.23-19.61,54.88-35.01,84.66-48.38,33.45-15.02,67.78-27.63,102.74-38.49,4.41-1.38,8.82-2.73,13.25-4.05.4-.11.81-.24,1.23-.37.68-.2,1.39-.41,2.12-.62.49-.14.99-.29,1.49-.43,1.84-.55,3.7-1.09,5.55-1.61,1.08-.31,2.18-.62,3.27-.94.43-.12.86-.25,1.29-.37.38-.11.75-.21,1.13-.32,2.46-.71,4.9-1.45,7.27-2.14.01.02.03.02.04.04,1.04-.3,2.01-.57,2.89-.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/Logo_mark.42eeeb4005a589b5f8d720f498371d2a.svg";
export { ForwardRef as ReactComponent };